<template>
  <div class="h-full">
    <el-row class="h-full">
      <el-col :span="showControlPanel ? 18 : 24" class="h-full">
        <div v-if="!isHistory" class="h-full w-full" :id="realEl"></div>
        <div v-else class="h-full w-full" :id="recordEl"></div>
      </el-col>
      <el-col
        :span="showControlPanel ? 6 : 0"
        class="h-full pl-10px"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div>
          <div>
            <div>切换内外网</div>
            <div>
              <el-switch
                @change="switchIntrannet"
                v-model="isIntrannet"
                inactive-text="内网"
                active-text="外网"
              >
              </el-switch>
            </div>
          </div>
          <div>
            <div>云台控制</div>
            <div>
              <el-switch
                @change="switchStatus"
                v-model="isHistory"
                inactive-text="实时播放"
                active-text="历史播放"
              >
              </el-switch>
            </div>
          </div>
          <div v-if="isHistory">
            <div class="mt-10px">
              <el-date-picker
                size="mini"
                v-model="selectedDatetime"
                style="width: 100%;"
                type="datetimerange"
                placeholder="选择日期时间"
              ></el-date-picker>
            </div>
            <el-row class="mt-10px">
              <el-button @click="startPlay">继续回放</el-button>
              <el-button @click="stopPlay">暂停回放</el-button>
            </el-row>
            <el-row class="mt-10px"></el-row>
          </div>
          <div class="directionCont" v-if="!isHistory">
            <!-- 云台容器 -->
            <!-- <div id="pantilt" style="width: 300px; height: 300px;"></div> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { IOTCameraApi } from '@wiz-api/iot-device-management'
import PlayerManager from '@/utils/icc/PlayerManager.js'

const iOTCameraApi = new IOTCameraApi()
export default {
  name: 'DHWSPlayerControl',
  props: {
    daHuaParams: {
      type: Object,
      default: () => {},
    },
    // 是否显示云台和历史播放的操作面板;默认进来是实时播放模式，控制面板打开
    showControlPanel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      player: {
        realPlayer: '', // 预览
        recordPlayer: '', // 录像
      }, // 播放器实例
      playerType: 'realPlayer', // 播放器类型
      // 窗口号
      selectIndex: 0,
      WSpanTilt: null, // 云台实例
      isHistory: false, // 播放模式；false = 实时播放；true = 历史播放，
      isIntrannet: true, // 内外网；false = 内网；true = 外网，
      selectedDatetime: [
        this.dayjs(new Date()).format('YYYY/MM/DD 00:00:00'),
        this.dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss'),
      ], // 回放开始、结束时间
      // 监控播放id
      realEl: '',
      recordEl: '',
    }
  },
  created() {
    if (this.daHuaParams.selectorId) {
      this.realEl = this.daHuaParams.selectorId
      this.recordEl = `dh-record-${this.daHuaParams.selectorId}`
    } else {
      this.realEl = `dh-player-${this.daHuaParams.id}`
      this.recordEl = `dh-record-${this.daHuaParams.id}`
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.infoRealPlayer(this.realEl)
    })
  },
  methods: {
    // 初始化播放器
    infoRealPlayer(el) {
      this.player[this.playerType] = new PlayerManager({
        el /** 实时预览容器id，创建多个播放器，传入不同的容器id即可 * */,
        type: this.playerType.replace('Player', '') /** real - 实时预览  record - 录像回放 * */,
        maxNum: 1 /** 一个播放器上限能播放的路数，可根据实际情况设置，支持 1 4 9 16 25 * */,
        num: 1 /** 初始化，页面显示的路数 * */,
        showControl: false /** 是否显示工具栏，默认显示 * */,
        prefixUrl: 'lib/video/DHPlayer' /** 解码库所在位置的前缀 * */,
        receiveMessageFromWSPlayer: (methods, data, err) => {
          /* 回调函数，可以在以下回调函数里面做监听 */
          switch (methods) {
            case 'initializationCompleted':
              console.log('初始化完成')
              // 初始化完成，可调用播放方法（适用于动态加载解码库）
              // 若回调未触发时就使用实时预览/录像回放，则无法播放。
              if (!this.isHistory) {
                this.playReal(true)
              } else {
                this.playHistory()
              }
              break
            case 'changeStreamType': // 主/辅码流切换回调
              console.log(data.channelData) // 通道数据
              console.log(data.streamType) // 码流类型 0-主码流  1-辅码流1  2-辅码流2
              console.log(data.selectIndex) // 窗口序号，从 0
              break
            case 'realSuccess': // 实时预览成功
              console.log('实时预览成功')
              break
            case 'realError': // 实时预览失败
              console.log('实时预览失败', err)
              break
            case 'notifyTalk':
              // 点击窗口上的对讲按钮触发的事件回调
              console.log('notifyTalk', data)
              break
            case 'talkError': // 对讲失败
              console.log('对讲失败')
              break
            case 'selectWindowChanged': // 选中的窗口发生改变
              console.log(data, '返回窗口信息')
              this.selectIndex = data.playIndex
              break
            case 'windowNumChanged': // 播放器显示的路数发生改变
              console.log(data, '返回显示的窗口数量')
              break
            case 'closeVideo': // 视频关闭回调
              // 点击关闭按钮引发的视频关闭进行提示
              // 切换视频引发的视频关闭不进行提示
              if (!data.changeVideoFlag) {
                console.log(`窗口${data.selectIndex}的视频已关闭`)
              }
              break
            case 'statusChanged': // 视频状态发生改变
              break
            case 'errorInfo': // 错误信息汇总
              console.log(data, '可打印查看错误消息')
              break
            default:
              break
          }
        },
      })
    },
    switchIntrannet(res) {
      this.$nextTick(() => {
        this.playReal(res)
        this.isIntrannet = res
      })
    },
    // 流地址方式播放实时预览
    async playReal(intrannet = false) {
      try {
        let wsURL = ''
        let rtspURL = null
        const streamType = 1
        const channelId = this.daHuaParams.code
        const deviceId = this.daHuaParams.id
        const inputJson = {
          data: {
            channelId,
            dataType: '1',
            streamType: '1',
          },
        }
        const params = {
          deviceId,
          inputJson: JSON.stringify(inputJson),
        }
        const [error, res] = await iOTCameraApi.getCameraStrerm(params)
        if (error || !res) {
          return
        }
        const data = JSON.parse(res).data
        let url = ''
        if (data.url.indexOf('|') > -1) {
          url = data.url.slice(0, data.url.indexOf('|'))
        } else {
          url = data.url
        }
        if (intrannet) {
          const urlTwo = data.url.slice(data.url.indexOf('|') + 1)
          url = urlTwo.slice(0, urlTwo.indexOf('|'))
        }
        rtspURL = `${url}?token=${data.token}`
        const midUrl = rtspURL.slice(rtspURL.indexOf('//') + 2)
        wsURL = `ws://${midUrl.slice(0, midUrl.indexOf('/'))}`
        console.log('rtspURLdata', data, wsURL)
        this.player[this.playerType].realByUrl({
          rtspURL, // 必传
          wsURL, // 必传
          selectIndex: this.selectIndex, // 必传, 播放窗口号
          channelId, // 必传, 通道id
          streamType, // 必传, 码流类型
          useH265MSE: false, // 软解
          playerAdapter: 'stretching', // 选传, selfAdaption 自适应 | stretching 拉伸
          channelData: {
            // 建议传, 通道树信息 --- 选传
            // id: channelCode, // {String} 通道编码
            // deviceCode: deviceCode, // {String} 设备编码
            // deviceType: deviceType, // {String} 设备类型
            // channelSeq: channelSeq, // {String|Number} 通道序号
          },
        })
      } catch (error) {
        console.log('拉取地址失败', error)
      }
    },
    // 回放
    async playHistory() {
      let wsURL = ''
      let rtspURL = ''
      const channelId = this.daHuaParams.code
      const records = ''
      const startTime = new Date().getTime(this.selectedDatetime[0])
      const endTime = new Date().getTime(this.selectedDatetime[1])
      const deviceId = this.daHuaParams.id
      const inputJson = {
        data: {
          channelId,
          dataType: '1',
          streamType: '1',
        },
      }
      const params = {
        deviceId,
        inputJson: JSON.stringify(inputJson),
      }
      const [error, res] = await iOTCameraApi.getCameraStrerm(params)
      if (error || !res) {
        return
      }
      const data = JSON.parse(res).data
      let url = ''
      if (data.url.indexOf('|') > -1) {
        url = data.url.slice(0, data.url.indexOf('|'))
      } else {
        url = data.url
      }
      rtspURL = `${url}?token=${data.token}`
      const midUrl = rtspURL.slice(rtspURL.indexOf('//') + 2)
      wsURL = `ws://${midUrl.slice(0, midUrl.indexOf('/'))}`
      this.player[this.playerType].recordByUrl({
        wsURL,
        rtspURL,
        channelId, // 必传, 通道id
        records: records || [], // 录像列表
        selectIndex: this.selectIndex, // 必传
        startTime, // 建议传，不传则会通过records数组中截取, 格式 // new Date().getTime() / 1000 【到秒时间戳】
        endTime, // 建议传，不传则会通过records数组中截取, 格式 // new Date().getTime() / 1000 【到秒时间戳】
        // playerAdapter: opt.playerAdapter, // 选传, , selfAdaption 自适应 | stretching 拉伸
        // channelData: opt.channelData || {}, // 选传,  通道信息
      })
    },
    // 切换播放模式
    switchStatus(res) {
      if (res) {
        // 历史播放
        this.$nextTick(() => {
          this.playerType = 'recordPlayer'
          this.infoRealPlayer(this.recordEl)
        })
      } else {
        // 实时播放
        this.$nextTick(() => {
          this.playerType = 'realPlayer'
          this.infoRealPlayer(this.realEl)
        })
      }
    },
    // 开始回放
    startPlay() {
      this.player[this.playerType].play(this.selectIndex)
    },
    // 停止回放
    stopPlay() {
      // 窗口号 selectIndex
      this.player[this.playerType].pause(this.selectIndex)
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
  },
  beforeDestroy() {
    this.player[this.playerType].destroy()
  },
}
</script>
